import {Component, Input} from '@angular/core';
import {AuthtokenResponse} from "../../../model/response/auth/authtoken-response.model";

@Component({
    selector: 'app-profile-view',
    templateUrl: './profile-view.component.html',
    standalone: false
})
export class ProfileViewComponent {

  @Input("user") user : AuthtokenResponse

}
